//@ts-check
import { CircularProgress } from "@mui/material";
import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useSearchParams } from "react-router-dom";
import StoryEmptyImg from "../../assets/storyEmpty.svg";
import characterStore from "../../store/CharactersStore";
import useUserDetailsStore from "../../store/UserStore";
import { CharacterTile } from "./CharacterTile";
import { DialogWrapper } from "../Dialog";
import { SubTitle } from "../molecules/subtitle";
import { TransparentButton } from "../Button/TransparentButton";

export const Characters = ({ childDetailsLoading }) => {
  // eslint-disable-next-line no-unused-vars
  const [searchParams, setSearchParams] = useSearchParams();
  const selectedCharactersIds = searchParams.get("c_id")?.split(",");
  const [selectedCharacters, setSelectedCharacters] = useState([]);
  const [
    characters,
    setSelectedCharacterForEdit,
    setIsAddCharacterVisible,
    setSelectedKidForCharacter,
    deleteCharacter,
  ] = characterStore((state) => [
    state.characters,
    state.setSelectedCharacterForEdit,
    state.setIsAddCharacterVisible,
    state.setSelectedKidForCharacter,
    state.deleteCharacter,
  ]);
  const [canAddCharacter] = useUserDetailsStore((state) => [
    state.canAddCharacter,
  ]);
  const [deleteCharacterDetail, setDeleteCharacter] = useState(null);
  const handleDeleteCharacter = () => {
    deleteCharacter(deleteCharacterDetail?.id);
    setDeleteCharacter(null);
  };

  useEffect(() => {
    if (characters.length > 0) {
      if (selectedCharactersIds && selectedCharactersIds.length > 0) {
        const selectedCharacters = characters.filter((kid) =>
          selectedCharactersIds.includes(kid.id)
        );
        setSelectedCharacters(selectedCharacters);
      }
    }
  }, [characters]);

  const FullPageLoading = () => {
    return (
      <div className="relative w-[100%] h-[80vh]">
        <div className="z-20 flex justify-center items-center absolute top-0 left-0 w-[100%] h-[100%] opacity-80 ">
          <CircularProgress sx={{ color: "#3CC3AA" }} />
        </div>
      </div>
    );
  };
  if (childDetailsLoading) {
    return <FullPageLoading />;
  }
  if (characters.length === 0 || !characters) {
    return (
      <div className="flex flex-col items-center justify-center">
        <img src={StoryEmptyImg} alt="empty story" />
        <p className="text-md my-4">
          You have no characters added. Let’s get started by adding a character!
        </p>
        <button
          className="px-10 py-2 rounded-full text-[#3CC3AA] font-bold text-lg border-2 border-solid border-[#3CC3AA]"
          onClick={() => {
            if (canAddCharacter) {
              setIsAddCharacterVisible(true);
            } else {
              toast(
                "You have hit the plan limit. See subscription details for more info"
              );
            }
          }}
        >
          + Add Character
        </button>
      </div>
    );
  }
  const isCharacterSelected = (character) =>
    selectedCharacters?.some((each) => each.id === character.id);

  let newSelectedCharacters = [...selectedCharacters];

  const handleCharacterSelect = (character) => {
    if (isCharacterSelected(character)) {
      newSelectedCharacters = [
        ...selectedCharacters.filter((each) => each.id !== character.id),
      ];
      setSelectedCharacters(newSelectedCharacters);
    } else {
      newSelectedCharacters = [...selectedCharacters, character];
      setSelectedCharacters(newSelectedCharacters);
    }
    //setting charcters ids in query params
    if (newSelectedCharacters.length === 0) {
      setSearchParams({
        tab: "characters",
      });
      return;
    }
    setSearchParams({
      tab: "characters",
      c_id: newSelectedCharacters.map((character) => character.id).join(","),
    });
  };

  return (
    <div className="container m-auto relative justify-center p-8">
      <DialogWrapper
        isOpen={Boolean(deleteCharacterDetail)}
        onClose={() => setDeleteCharacter(null)}
        header={null}
      >
        <SubTitle>
          Do you want to delete character{" "}
          <strong>{deleteCharacterDetail?.name}</strong>?
        </SubTitle>
        <div className="w-full flex justify-center my-4">
          <TransparentButton
            handleButtonClick={() => setDeleteCharacter(null)}
            className={"mx-2"}
          >
            Cancel
          </TransparentButton>
          <TransparentButton
            handleButtonClick={handleDeleteCharacter}
            theme="red"
            className={"mx-2"}
          >
            Delete
          </TransparentButton>
        </div>
      </DialogWrapper>
      <div className="flex  gap-x-6 gap-y-4 justify-center items-center cursor-pointer w-full flex-wrap">
        {characters?.map((character) => (
          <CharacterTile
            onClick={() => handleCharacterSelect(character)}
            key={character.id}
            character={character}
            isSelected={isCharacterSelected(character)}
            handleActionClick={() => {
              setSelectedCharacterForEdit(character);
              setIsAddCharacterVisible(true);
              setSelectedKidForCharacter({ id: character.human_id });
            }}
            deleteKid={(id) => {
              setDeleteCharacter(character);
            }}
          />
        ))}
      </div>
    </div>
  );
};
